import getCursorPosInBlock from './getCursorPosInBlock';
import pasteParaBlock from './paste/paste.parablock';
import customSingleLineNode from './paste/customSingleLineNode';
import { cleanNodeText } from './cleanNodeText';

export default (params) => {
  const { copiedFragment, editor } = params;

  // If there is no copied fragment, return false
  if (!copiedFragment) return false;

  /**
   * Extract blocks from the copied fragment
   */
  const copiedBlocks = copiedFragment?.getBlocksAsArray();

  const {
    value: {
      focusBlock: initialFocusBlock,
      selection: { isExpanded },
    },
  } = editor;

  if (isExpanded) editor.delete();

  const initialFocusPoint = getCursorPosInBlock({
    editor,
  });
  /**
   * Iterate through copied block and insert them according to the prev/focus block
   */
  copiedBlocks.forEach((incomingBlock, index) => {
    const {
      value: { document },
    } = editor;
    const {
      value: { focusBlock },
    } = editor;
    const { nodes: focusNodes } = focusBlock;
    const { key: focusBlockKey } = focusBlock;
    const focusBlockNodes = focusNodes;
    const { type: incomingBlockType, key: incomingBlockKey } = incomingBlock;
    const copiedParentBlock = copiedFragment?.getParent(incomingBlockKey);
    const { type: copiedParentBlockType } = copiedParentBlock;

    const { nodes: incomingChildNodes } = incomingBlock;

    const cleanedChildNodes = incomingChildNodes.map((node) => {
      return cleanNodeText(node);
    });

    const updatedIncomingBlock = incomingBlock.set('nodes', cleanedChildNodes);

    /**
     * If the copied block is not a paragraph
     *
     * NOTE:
     * 1. The least depth of block is paragraph.
     * 2. When a fragment is copied/cut and if we extract blocks out of the fragment,
     *    slate gives us the least depth blocks
     * 3. If a least depth block is not a paragraph then we can suppose it as a
     *    custom node
     * 4. Once we idenitfy it is a custom node, we can extract the child nodes and
     *    extract text nodes out of it.
     */
    if (incomingBlockType !== 'paragraph') {
      customSingleLineNode({
        editor,
        incomingBlock: updatedIncomingBlock,
        focusBlock,
        focusBlockNodes,
      });
    } else {
      pasteParaBlock({
        editor,
        index,
        copiedFragment,
        incomingBlock: updatedIncomingBlock,
        incomingBlockKey,
        copiedParentBlock,
        copiedParentBlockType,
        incomingBlockType,
        document,
        focusBlockKey,
        focusBlockNodes,
        focusBlock,
        copiedBlocks,
        initialFocusBlock,
        initialFocusPoint,
      });
    }

    return true;
  });
  return true;
};
